export { default as careersBgSvg } from './careersBg.svg';
export { default as technologiesUseBgSvg } from './technologiesUseBg.svg';
export const ourServices = require('./our-services.jpg?webp');
export const bgOurServices = require('./bg-our-services.png?webp');
export const careersPhoto = require('./careersPhoto.jpg?webp');
export const careersPhoto2x = require('./careersPhoto-2x.jpg?webp');
export const technologiesUse = require('./technologiesUse.jpg?webp');
export const technologiesUse2x = require('./technologiesUse-2x.jpg?webp');
export const offers1 = require('./offers/offers1.jpg?webp');
export const offers1x2 = require('./offers/offers1-2x.jpg?webp');
export const offers2 = require('./offers/offers2.jpg?webp');
export const offers2x2 = require('./offers/offers2-2x.jpg?webp');
export const offers3 = require('./offers/offers3.jpg?webp');
export const offers3x2 = require('./offers/offers3-2x.jpg?webp');
export const offers4 = require('./offers/offers4.jpg?webp');
export const offers4x2 = require('./offers/offers4-2x.jpg?webp');
export const offers5 = require('./offers/offers5.jpg?webp');
export const offers5x2 = require('./offers/offers5-2x.jpg?webp');
